export * from "./MedicalCardTemplatesDialod";
